import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { CKEditorModule } from 'ng2-ckeditor';

import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { CkeditorComponent } from './ckeditor/ckeditor.component';
import { DatetimepickerComponent } from './datetimepicker/datetimepicker.component';
import { InboxComponent } from './inbox/inbox.component';
import { FilterPipe } from './pipes/filter.pipe';

import { OwlDateTimeModule, OwlNativeDateTimeModule } from 'ng-pick-datetime';
import { ButtonDatetimepickerComponent } from './button-datetimepicker/button-datetimepicker.component';
import { FormsModule } from '@angular/forms';
import { SortPipe } from './pipes/sort.pipe';
import { CheckPipe } from './pipes/check.pipe';
import { ViewVideoModalComponent } from './view-video-modal/view-video-modal.component';
import { MalihuScrollbarModule } from 'ngx-malihu-scrollbar';
import { RangeSliderComponent } from './range-slider/range-slider.component';
import { StudentNamePipe } from './pipes/student-name.pipe';


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    CKEditorModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    MalihuScrollbarModule.forChild()
  ],
  declarations: [
    HeaderComponent,
    FooterComponent,
    SidebarComponent,
    CkeditorComponent,
    DatetimepickerComponent,
    InboxComponent,
    FilterPipe,
    ButtonDatetimepickerComponent,
    SortPipe,
    CheckPipe,
    ViewVideoModalComponent,
    RangeSliderComponent,
    StudentNamePipe
  ],
  exports: [
    HeaderComponent,
    FooterComponent,
    SidebarComponent,
    CkeditorComponent,
    DatetimepickerComponent,
    InboxComponent,
    FilterPipe,
    ButtonDatetimepickerComponent,
    SortPipe,
    CheckPipe,
    ViewVideoModalComponent,
    RangeSliderComponent,
    StudentNamePipe
  ]
})
export class SharedModule { }



// WEBPACK FOOTER //
// G:/UTL/Alumni/Alumni-ANG/src/app/shared/shared.module.ts